import { Bluesky } from "../Icons/Bluesky";
import { Instagram } from "../Icons/Instagram";
import { LinkedIn } from "../Icons/LinkedIn";
import { Twitter } from "../Icons/Twitter";

export const SocialLink = ({ socialNetwork, url }: { socialNetwork: "Twitter" | "LinkedIn" | "Instagram" | "Bluesky"; url: string }) => {
	return (
		<>
			{socialNetwork === "Twitter" && (
				<a className="icon-link" href={url} aria-label={socialNetwork}>
					<div className="icon-box">
						<Twitter />
					</div>
					<span>X</span>
				</a>
			)}
			{socialNetwork === "LinkedIn" && (
				<a className="icon-link" href={url} aria-label={socialNetwork}>
					<div className="icon-box">
						<LinkedIn />
					</div>
					<span>LinkedIn</span>
				</a>
			)}
			{socialNetwork === "Instagram" && (
				<a className="icon-link" href={url} aria-label={socialNetwork}>
					<div className="icon-box">
						<Instagram />
					</div>
					<span>Instagram</span>
				</a>
			)}
			{socialNetwork === "Bluesky" && (
				<a className="icon-link" href={url} aria-label={socialNetwork}>
					<div className="icon-box">
						<Bluesky />
					</div>
					<span>Bluesky</span>
				</a>
			)}
		</>
	);
};
